import React from 'react'
import { IconButton } from '@mui/material'
import { PARTIAL_OPACITY } from 'shared/constants'
import { Search, CloseIcon } from '../Icon'
import { IconContainer, SearchField } from './styles'
import type { SearchInputProps } from './types'

const SearchInput: React.FC<SearchInputProps> = ({ onChange, label, clearText, value }) => (
  <SearchField
    variant="outlined"
    value={value}
    label={label}
    slotProps={{
      input: {
        endAdornment: value ? (
          <IconButton onClick={clearText}>
            <CloseIcon />
          </IconButton>
        ) : (
          <IconContainer>
            <Search fillOpacity={PARTIAL_OPACITY} />
          </IconContainer>
        ),
      },
      htmlInput: {
        'data-testid': 'search-input',
      },
    }}
    onChange={onChange}
  />
)

export default SearchInput
